<template>
  <v-container fluid>
    <v-row class="mb-5">
      <v-col>
        <span class='font-16 font-w-700'>สรุปรายละเอียดโปรโมชัน ณ ร้าน Café Amazon  ประจำเดือนของเดือน{{dateStr}}</span>
        <DisplayBtn v-model="display"/>
      </v-col>
    </v-row>
    <v-card rounded outlined>
      <v-container fluid>
        <v-row class="text-right row-header flex-nowrap">
          <v-col
            v-for="(header, i) in headers"
            :key="`hday-${i}`"
            :class="`py-3 ${header.class}`">
            <span class="d-none d-sm-inline">{{header.dddd}}</span>
            <span class="d-sm-none">{{header.dd}}</span><br>
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid class="pa-0">
        <v-row no-gutters class="content">
          <v-col class="promo-calendar month">
            <v-container fluid class="pa-0">
              <v-row
                v-for="(week, i) in weeks"
                :key="`week-${i}`"
                no-gutters
                class="flex-nowrap week">
                <v-col
                  v-for="day in week.days"
                  :key="`day-${day.D}`"
                  :class="day.class">
                  <v-row no-gutters class="fill-height">
                    <v-col cols='12' class="text-right align-self-start">
                      <v-avatar
                        :color="day.isCur ? '#F1545B' : ''"
                        :class="'ma-1 '+(day.isCur ? 'active' : '')"
                        size="24">{{day.D}}</v-avatar>
                    </v-col>
                    <v-col cols='12' class="align-self-end" v-if="day.thismonth && (day.count.more > 0)">
                      <div class="more px-2 font-12 font-weight-500">
                        โปรโมชันทั้งหมด ({{day.count.more}})
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
                <div
                  v-for="promotion in week.promotions"
                  :key="`bar-${i}-${promotion.Id}`"
                  :ref="`bar-${i}-${promotion.Id}`"
                  class="bar px-2 font-12 font-weight-500"
                  :style="calBarStyle(week.start, promotion)">
                  {{promotion.PromotionName__c}}
                </div>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import DisplayBtn from '@/components/calendar/sub/DisplayBtn.vue'

export default {
  components: { DisplayBtn },
  data() {
    return {
      display: 'calendar',
    }
  },
  props: {
    promotions: { types: Array, require: true },
    form: { types: Object, require: true },
  },
  watch:{
    display(newVal) {
      this.$emit('changeDisplay', newVal)
    },
    promotions() {
      this.$nextTick(this.calBar)
    },
  },
  methods: {
    promotionBars() {
      const from = this.dateFirst()
      const daysInMonth = from.daysInMonth()
      const bars = []
      const days = [...Array(daysInMonth).keys()].map(day => { return {bars:[false,false,false], total:0, more:0}})
      this.promotions.forEach(promotion => {
        let free=false, start=-1, end=daysInMonth, slots= [0,1,2]

        start = moment(promotion.StartDate__c).diff(from, 'day')
        end = 'EndDate__c' in promotion ? moment(promotion.EndDate__c).diff(from, 'day') : daysInMonth

        slots.forEach(slot => {
          if (free) return

          let _free = true

          for(let i = 0; i < daysInMonth; i++){
            if (i < start) continue
            if (i > end) break

            if (days[i].bars[slot]) {
              _free = false
            }
            if (slot == 0) {
              days[i].total ++
              days[i].more ++
            }
          }

          if (!_free) return
          free = true

          for(let i = 0; i < daysInMonth; i++){
            if (i < start) continue
            if (i > end) break

            days[i].bars[slot] = true
            days[i].more --
          }

          promotion.slot = slot
          promotion.start = start
          promotion.end = end
          bars.push(promotion)
        })
      })
      return { bars, days }
    },
    dateFirst(){
      const date = moment(new Date(this.form.year, this.form.month, 1))
      return date
    },
    calBarStyle(day1, promotion) {
      const first = moment(day1)
      const last = moment(day1).add(6, 'day')
      const style = {}
      let top = 0, left = 0, right = 0

      top = (promotion.slot * 19) + 30

      const start = moment(promotion.StartDate__c)
      if (start >= first) {
        const diff = start.diff(first, 'day')
        left = Math.min((100 * diff / 7), 100)
        style['margin-left']='2px'
      }else{
        style['border-bottom-left-radius']='0px'
        style['border-top-left-radius']='0px'
      }

      const end = 'EndDate__c' in promotion ? moment(promotion.EndDate__c) : false
      if (end && end <= last) {
        const diff = last.diff(end, 'day')
        right = Math.min((100 * diff / 7), 100)
        style['margin-right']='2px'
      }else{
        style['border-bottom-right-radius']='0px'
        style['border-top-right-radius']='0px'
      }

      style.top=`${top}px`
      style.left=`${left}%`
      style.right=`${right}%`
      style['background-color'] = this.barColor(promotion.PromotionType__c)

      return style
    },
    barColor(type) {
      if (type in this.types) return this.types[type]
      return '#637381'
    },
    weekDays(day1, counts) {
      const today = new Date()
      const date = moment(day1)
      date.subtract(1, 'day')
      return [...Array(7).keys()].map(day => {
        date.add(1, 'day')
        const thismonth = date.month() == this.form.month
        return {
          'dd': date.format('dd').replace('.', ''),
          'dddd': date.format('dddd'),
          'D': date.format('D'),
          'isCur': date.isSame(today, 'day'),
          'class': !thismonth? 'month-diff': '',
          'thismonth': thismonth,
          'count': counts[date.date() - 1],
        }
      })
    },
    weekPromotions(day1, promotions) {
      const from = moment(day1)
      const to = moment(day1).add(6, 'day')
      return promotions.filter(promotion => {
        const start = moment(promotion.StartDate__c)
        if (to < start) return false

        if ('EndDate__c' in promotion) {
          const end = moment(promotion.EndDate__c)
          if (from > end) return false
        }
        return true
      })
    },
  },
  computed: {
    ...mapGetters({
      types: 'Calendar/getTypes',
    }),
    dateStr() {
      const date = new Date(this.form.year, this.form.month)
      return moment(date).format('MMMM') + ' ' + (this.form.year + 543)
    },
    headers() {
      const date = moment()
      return [...Array(7).keys()].map(day => {
        date.day((day+1)%7)
        return {
          'dd': date.format('dd').replace('.', ''),
          'dddd': date.format('dddd'),
        }
      })
    },
    weeks() {
      const first = this.dateFirst()
      const date = this.dateFirst().weekday(1)
      const bar = this.promotionBars()
      const result = []
      let i = 0
      if (date < first) {
        result.push({
          i: i++,
          name: date.format('D M'),
          start: moment(date),
          days: this.weekDays(date, bar.days),
          promotions: this.weekPromotions(date, bar.bars),
        })
      }
      while(this.form.month >= date.month()) {
        if (this.form.month != date.month()) {
          date.weekday(8)
          continue
        }
        result.push({
          i: i++,
          name: date.format('D M'),
          start: moment(date),
          days: this.weekDays(date, bar.days),
          promotions: this.weekPromotions(date, bar.bars),
        })
        date.weekday(8)
      }
      return result
    },
  }
};
</script>
